// import React from "react";

// function Loader() {
//   return <span class="loader"></span>;
// }

// export default Loader;
// import React from "react";
import { createPortal } from "react-dom";

function Loader() {
  return createPortal(
    <div className="overlay">
      <span className="loader"></span>
    </div>,
    document.body,
  );
}

export default Loader;
